import { GraphQL } from "@graphql/graphQL";
import { CreateApplianceMutation, CreateApplianceMutationVariables } from "@models/graphql";
import { ApolloError } from "apollo-client";
import { useState } from "react";
import { MutationHookOptions, useMutation } from "@apollo/react-hooks";

const defaultCreateApplianceOptions: MutationHookOptions<CreateApplianceMutation, CreateApplianceMutationVariables> = {

};

export const useCreateAppliance = (options?: MutationHookOptions<CreateApplianceMutation, CreateApplianceMutationVariables>) => {
    const [hookState, setHookState] = useState<{
        isLoading: boolean;
        data?: CreateApplianceMutation;
        error?: ApolloError;
    }>({
        isLoading: false
    });

    const [mutation] = useMutation<CreateApplianceMutation, CreateApplianceMutationVariables>(GraphQL.createAppliance);

    const createAppliance = async (variables: CreateApplianceMutationVariables) => {
        setHookState({
            isLoading: true
        });

        try {
            const response = await mutation({
                ...defaultCreateApplianceOptions,
                ...options,
                variables
            });

            setHookState({
                data: response.data,
                isLoading: false
            });

            return {
                data: response.data,
                error: response.errors
            };
        } catch (error) {
            setHookState({
                error,
                isLoading: false
            });

            return {
                error
            };
        }
    };

    return {
        isLoading: hookState.isLoading,
        error: hookState.error,
        data: hookState.data,
        createAppliance
    };
};
